import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfa değiştiğinde en üste scroll et
    window.scrollTo(0, 0);
  }, [pathname]);

  // Filtre değişikliklerinde scroll pozisyonunu ayarla
  const handleFilterScroll = () => {
    // Navbar yüksekliği (60px) kadar yukarı scroll et
    window.scrollTo({
      top: 60,
      behavior: 'smooth'
    });
  };

  // Global olarak erişilebilir olması için window nesnesine ekle
  window.handleFilterScroll = handleFilterScroll;

  return null;
};

export default ScrollToTop; 